import { Link } from 'react-router';
import { ButtonLink, Logo } from '../../components/ui';
import { cx } from '../../components/ui/cx';
import styles from './HomeHero.module.css';

interface HomeHeroProps {
  /** Decorative copy behind the auth card: no focusable links. */
  decorative?: boolean;
  /** Where «Войти» points; the author may already be signed in. */
  signedIn?: boolean;
}

/** Header and hero from the auth backdrop in the design. */
export function HomeHero({ decorative, signedIn }: HomeHeroProps) {
  const tab = decorative ? -1 : undefined;
  return (
    <div className={cx(styles.hero, decorative ? styles.decorative : undefined)} aria-hidden={decorative || undefined}>
      <header className={styles.header}>
        <Link to="/" tabIndex={tab} className={styles.brand}>
          <Logo wordSize={19} />
        </Link>
        <nav className={styles.nav}>
          {signedIn ? (
            <ButtonLink to="/admin" variant="primary" size="md" tabIndex={tab} className={styles.navButton}>
              Перейти в админку
            </ButtonLink>
          ) : (
            <>
              <ButtonLink to="/login" variant="secondary" size="md" tabIndex={tab} className={styles.navButton}>
                Войти
              </ButtonLink>
              <ButtonLink to="/register" variant="primary" size="md" tabIndex={tab} className={styles.navButton}>
                Создать академию
              </ButtonLink>
            </>
          )}
        </nav>
      </header>
      <section className={styles.body}>
        <span className={styles.kicker}>Платформа онлайн-курсов</span>
        <h1 className={styles.title}>
          Своя онлайн-школа
          <br />
          на своём адресе
        </h1>
        <p className={styles.lead}>Курсы из уроков с видео, доступ по приглашениям и промокодам.</p>
      </section>
    </div>
  );
}
